import { render, staticRenderFns } from "./PassportRegisteration.vue?vue&type=template&id=68e86d0b&scoped=true"
import script from "./PassportRegisteration.vue?vue&type=script&lang=js"
export * from "./PassportRegisteration.vue?vue&type=script&lang=js"
import style0 from "./PassportRegisteration.vue?vue&type=style&index=0&id=68e86d0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e86d0b",
  null
  
)

export default component.exports